// =============================================================================
// state
// =============================================================================
const state = {
  loginToken: null,
};
// =============================================================================
// getters
// =============================================================================
const getters = {
  login_token: state => state.loginToken,
};
// =============================================================================
// actions
// =============================================================================
const actions = {
};
// =============================================================================
// mutations
// =============================================================================
const mutations = {
  set_data (state, value) {
    state.loginToken = value.token;
  },
  logout (state, value) {
    state.loginToken = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
